import { Field } from 'formik'
import { Component } from 'react'
import moment from 'moment-timezone'
import getTranslationTime from '../../Translation/func/getTranslationTime'

class EditEventFormTime extends Component {
    constructor(props) {
        super(props)

        this.setValue = this.setValue.bind(this)
    }

    formatValue(value) {
        const {timezone, currentLang, debug } = this.props 

        return value ? getTranslationTime('time', timezone, currentLang, value, debug) : ''
    }

    setValue(e, setFieldValue) {
        const { name, date, timezone } = this.props
        
        if(e.currentTarget.value) {
            const timeArray = e.currentTarget.value.split(':')

            if(2 == timeArray.length) {
                const momentDate = moment.tz(date, timezone)
                const time = momentDate.hours(timeArray[0]).minutes(timeArray[1]).format("YYYY-MM-DDTHH:mm:ssZ")

                setFieldValue(name, time)
            }
        }
    }

    render() {
        const { name, value, inputRef } = this.props
    

        return (
            <Field name={name}>
                {({ 
                    field,
                    form : { setFieldValue }
                }) => (
                    <input 
                        {...field} 
                        type="time"
                        id={name}
                        value={this.formatValue(value)}
                        onChange={e => this.setValue(e, setFieldValue)}
                        ref={inputRef}
                    />
                )}
            </Field>
        )
    }
}

export default EditEventFormTime